import React from 'react';
import I18nWrapper from './src/components/i18n-wrapper';

export const wrapRootElement = ({ element }) => {
  return <I18nWrapper>{element}</I18nWrapper>;
};
